module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/case-study-8da71344692370f141055b322f5184e0.png";